import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ClaimJobPaymentItem.List.IRequest;
type Response = Api.Finance.ClaimJobPaymentItem.List.IResponse;
type Headers = Api.Finance.ClaimJobPaymentItem.List.IHeaders;
const url = '/api/Finance/ClaimJobPaymentItem';
export default async function claimJobPaymentItemListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
